export default {
  to: 'To:',
  enterNameOrPhoneNumber: 'Enter Number',
} as const;
